var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticStyle: { "min-height": "400px" },
      attrs: { id: "auth_helper_page" }
    },
    [_c("div", { staticClass: "container" })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }